import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { _, core } from '@icc/shared/helpers';
import { StepComponent, ModalService, SharedFacade } from '@icc/configurator/shared';
import { AccessoriesLocationPageComponent } from '../accessories-location-page/accessories-location-page.component';
import { WindowAccessoriesService } from './accessories.service';
import { IccAccessory, IccAccessoryColor } from '@icc/construction-elements/types';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { Subscription } from 'rxjs';
import { PriceService } from '@icc/price';
import { WindowAccessoryFacade } from '../+state/accessory.facade';
import { ComplementaryGoodsService } from '../complementary-goods.service';
import { AccessoriesComponent } from '@icc/construction-elements/configurator';

@Component({
    selector: 'icc-window-accessories',
    templateUrl: './accessories.component.html',
    styleUrls: ['./accessories.component.scss'],
    standalone: false
})
export class WindowAccessoriesComponent extends AccessoriesComponent implements OnInit, OnDestroy {
    complementaryAccessories$ = this.accessoriesFacade.complementaryAccessories$;
    complementarySills$ = this.accessoriesFacade.complementarySills$;
    complementaryCassonettos$ = this.accessoriesFacade.complementaryCassonettos$;
    complementaryFillings$ = this.accessoriesFacade.complementaryFillings$;
    complementaryProfiles$ = this.accessoriesFacade.complementaryProfiles$;
    sideAccessories$ = this.accessoriesFacade.sideAccessories$;
    sideProfiles$ = this.accessoriesFacade.sideProfiles$;

    sashes$ = this.accessoriesFacade.sashes$;
    isAccessoryConfigurator$ = this.accessoriesFacade.isAccessoryConfigurator$;

    private isAccessoryConfigurator = false;

    constructor(
        protected accessoriesFacade: WindowAccessoryFacade,
        protected sharedFacade: SharedFacade,
        protected modalService: ModalService,
        protected accessoriesService: WindowAccessoriesService,
        protected complementaryGoodsService: ComplementaryGoodsService,
        protected priceService: PriceService,
        @Inject(APP_CONFIG) protected config: AppConfigFactory
    ) {
        super(
            accessoriesFacade,
            sharedFacade,
            modalService,
            accessoriesService,
            priceService,
            config
        );
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.complementaryGoodsService.loaded.accessory) {
            this.complementaryGoodsService.loadAccessories();
        }
        this.subscriptions.push(
            this.accessoriesFacade.isAccessoryConfigurator$.subscribe(isAccessory => {
                this.isAccessoryConfigurator = isAccessory;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    addAccessoriesToPart() {
        this.modalService.open({
            pageComponent: AccessoriesLocationPageComponent,
        });
    }

    addComplementaryAccessories() {
        this.complementaryGoodsService.openModalAccessories().then(() => {
            this.sharedFacade.closePage();
        });
    }

    addComplementarySills() {
        this.complementaryGoodsService.openModalSills().then(() => {
            this.sharedFacade.closePage();
        });
    }

    addComplementaryCassonetto() {
        this.complementaryGoodsService.openModalCassonettos().then(() => {
            this.sharedFacade.closePage();
        });
    }

    addComplementaryFilling() {
        this.complementaryGoodsService.openModalFilling().then(() => {
            this.sharedFacade.closePage();
        });
    }

    addComplementaryProfile() {
        this.complementaryGoodsService.openModalProfile().then(() => {
            this.sharedFacade.closePage();
        });
    }

    remove(sash: any, accessory: IccAccessory, type?: string) {
        if (this.isAccessoryConfigurator) {
            this.complementaryGoodsService.remove(accessory, type || 'accessory');
        } else {
            this.accessoriesService.remove(sash, accessory);
        }
    }

     edit(accessory: IccAccessory, type?: string) {
        if (this.isAccessoryConfigurator) {
            this.complementaryGoodsService.edit(accessory, type || 'accessory');
        }
    }

    getColorCassonetto(colorId, colors = this.complementaryGoodsService.cassonettosData.colors) {
        const color = core.fIdO(colors, colorId);
        if (color) {
            return color.name;
        }
    }

    isEnabledType(type: 'accessory' | 'glass' | 'profile' | 'cassonetto' | 'windowsill') {
        return this.complementaryGoodsService.isEnabledType(type)
    }

    hasSpaces(accessory) {
        return this.accessoriesService.getAccessorySpaces(accessory, true).length > 0;
    }

    getSpaces(accessory) {
        return this.accessoriesService.getAccessorySpaces(accessory, true);
    }

    setSpace(selected, accessory) {
        this.accessoriesService.setAccessorySpaces(accessory, selected);
    }

}
